$(document).on('click', '.btn-triger', function(){
    $(this).closest('.float-btn-group').toggleClass('open');
});
$(document).on('click', 'a.btn-float', function(){
    $(this).closest('.float-btn-group').toggleClass('open');
});